export enum ResourceSource {
  RECCO = 'RECCO',
  EXTERNAL = 'EXTERNAL',
  NURTURE = 'NURTURE',
  CRED = 'CRED',
  FEEDBACK = 'FEEDBACK',
}

export class Resource {
  accountId: string;
  externalId: string;
  id: string;
  type: 'gif' | 'photo' | 'video';
  url: string;

  static getMediaType(URL = ''): 'gif' | 'photo' | 'video' {
    const url = URL.toLowerCase();
    if (['.gif'].some(ext => url.includes(ext))) {
      return 'gif';
    }
    if (['.jpg', '.jpeg', '.png'].some(ext => url.includes(ext))) {
      return 'photo';
    }
    if (['.mp4', '.quicktime', '.mov'].some(ext => url.includes(ext))) {
      return 'video';
    }
    return 'photo';
  }

  constructor(json: any) {
    this.accountId = json.accountId;
    this.externalId = json.externalId;
    this.id = json._id || json.id;
    this.type = json.url && Resource.getMediaType(json.url);
    this.url = json.url;
  }
}
